export default "__VITE_ASSET__ffea46fc__"